export const SET_USER = 'SET_USER'
export const LOGOUT_USER = 'LOGOUT_USER'
export const SET_MARKETING_PREFERENCES = 'SET_MARKETING_PREFERENCES'
export const SET_JOB_IN_DRAFT = 'SET_JOB_IN_DRAFT'
export const REFRESH_JOB_IN_DRAFT = 'REFRESH_JOB_IN_DRAFT'
